import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {translate} from '../../services';
import {modalClose, modalOpen} from '../../actions/pageSetup';
import {objectIsEmpty, isEmpty} from '../../utils/validation';
import {fetchVotes, fetchFlag, fetchPostedReview, fetchReviewsEligibility} from '../../utils/fetch';
import {slideInModalOnClick} from '../../utils/slideInModalOnClick';
import {GUEST, REGISTERED, UNAUTHENTICATED} from '../../constants/userTypes';
import Reviews from '../../components/Product/Reviews/ReviewsLazy';
import ModalContainer from '../../containers/Modal/ModalContainer';
import ReviewsForm from '../../components/Product/Reviews/ReviewsForm/ReviewsFormLazy';
import selectS3host from '../../entities/pageSetup/apiHosts/selectors/selectS3host';
import fetchReviews from './api/fetchReviews';

class ReviewsContainer extends Component {
  constructor() {
    super();
    this.state = {
      displayReviewForm: false,
      reviewErrorMessageStars: '',
      reviewErrorMessageCaptions: '',
      slideInModal: false,
      reviewsAlreadyVotedIds: []
    };

    this.incrementVotes = this.incrementVotes.bind(this);
    this.flagAsInappropriate = this.flagAsInappropriate.bind(this);
    this.evaluateEligibility = this.evaluateEligibility.bind(this);
    this.submitReview = this.submitReview.bind(this);
    this.validateReview = this.validateReview.bind(this);
    this.closeReviewsModalOnClick = this.closeReviewsModalOnClick.bind(this);
  }

  componentDidMount() {
    const {windowPosition, reviewsIsFetched} = this.props;

    // this should not be possible until we stop starting always at the top "onRouterUpdate"
    if (windowPosition > 0 && !reviewsIsFetched) {
      this.getReviews();
    }
  }

  componentDidUpdate(prevProps) {
    const {designId, windowPosition, reviewSummary, reviewsIsFetching, reviewsIsFetched} = this.props;

    if (designId !== prevProps.designId) {
      this.getReviews();
    }

    if (!reviewsIsFetching && !reviewsIsFetched && (prevProps.windowPosition !== windowPosition) && isEmpty(reviewSummary)) {
      this.getReviews();
    }
  }

  getReviews() {
    const {dispatchReviews} = this.props;

    dispatchReviews();
  }

  incrementVotes(designId, review, voteDirection) {
    const {dispatchVotes} = this.props;

    dispatchVotes(designId, review.id, voteDirection)
      .catch((error) => {
        if (error.status === 403) {
          this.setVotedReview(review.id);
        }
      });
  }

  flagAsInappropriate(designId, review) {
    const {dispatchflagAsInappropriate} = this.props;

    dispatchflagAsInappropriate(designId, review.id)
      .catch((error) => {
        if (error.status === 403) {
          this.setVotedReview(review.id);
        }
      });
  }

  setVotedReview(id) {
    const reviewsVoted = this.state.reviewsAlreadyVotedIds.slice();

    if (reviewsVoted.length === 0 || !reviewsVoted.includes(id)) {
      reviewsVoted.push(id);
      this.setState({
        reviewsAlreadyVotedIds: reviewsVoted
      });
    }
  }

  evaluateEligibility() {
    const {dispatchReviewsEligibility, designId} = this.props;

    dispatchReviewsEligibility(designId)
      .then(() => {
        this.props.reviewEligible && slideInModalOnClick(this);
        this.props.reviewEligible && this.props.openModal('reviews-form');
      });
  }

  submitReview(review) {
    const {dispatchPostedReview, designId, closeModal} = this.props;

    isEmpty(this.state.reviewErrorMessageStars) && isEmpty(this.state.reviewErrorMessageCaptions) && dispatchPostedReview(designId, review)
      .then(() => {
        setTimeout(() => {
          closeModal();
        }, 5000);
      });
  }

  validateStarsAmount(starsAmount) {
    if (starsAmount === 0) {
      this.setState({
        reviewErrorMessageStars: translate('reviews.reviewsForm.validateRating')
      });
    } else {
      this.setState({
        reviewErrorMessageStars: ''
      });
    }
  }

  validateCaptions(photos) {
    let error = '';

    photos.forEach(function(element) {
      if (!element.caption) {
        error = translate('reviews.reviewsForm.validateCaptions');
      }
    });

    this.setState({
      reviewErrorMessageCaptions: error
    });
  }

  validateReview(starsAmount, photos) {
    this.setState({
      reviewErrorMessageStars: '',
      reviewErrorMessageCaptions: ''
    });
    this.validateStarsAmount(starsAmount);
    this.validateCaptions(photos);
  }

  closeReviewsModalOnClick() {
    this.setState({
      displayReviewForm: false
    });
  }

  render() {
    const {
      locale, reviews, reviewSummary, reviewSummaryData, reviewEligible, reviewSubmitted, designId,
      designFileName, designName, userType, displayModal, modalName, isDesktop, s3host
    } = this.props;
    const reviewDataAvailable = !isEmpty(reviewSummary) && reviewSummaryData.dimensions.length > 1;

    return (
      <React.Fragment>
        {reviews && <Reviews
          isDesktop={isDesktop}
          designId={designId}
          reviews={reviews}
          reviewsVoted={this.state.reviewsAlreadyVotedIds}
          reviewSummaryData={reviewSummaryData}
          reviewDataAvailable={reviewDataAvailable}
          locale={locale}
          reviewEligible={reviewEligible}
          reviewSubmitted={reviewSubmitted}
          userType={userType}
          incrementVotes={this.incrementVotes}
          flagAsInappropriate={this.flagAsInappropriate}
          evaluateEligibility={this.evaluateEligibility}/>}
        {(reviewEligible && displayModal && (modalName === 'reviews-form')) &&
          <ModalContainer
            slideInModal={this.state.slideInModal}
            modalClose={this.closeModal}
            contents={<ReviewsForm
              reviews={reviews}
              reviewSummary={reviewSummary}
              reviewSummaryData={reviewSummaryData}
              submitReview={this.submitReview}
              errorMessageStars={this.state.reviewErrorMessageStars}
              errorMessageCaptions={this.state.reviewErrorMessageCaptions}
              displayReviewForm={this.state.displayReviewForm}
              validateReview={this.validateReview}
              designId={designId}
              designName={designName}
              designFileName={designFileName}
              reviewSubmitted={reviewSubmitted}
              s3host={s3host}
              closeReviewsModalOnClick={this.closeReviewsModalOnClick}/>}
          />}
      </React.Fragment>
    );
  }
}

ReviewsContainer.propTypes = {
  locale: PropTypes.string.isRequired,
  designId: PropTypes.number.isRequired, // from parent
  designName: PropTypes.string.isRequired,
  dispatchReviews: PropTypes.func.isRequired,
  dispatchVotes: PropTypes.func.isRequired,
  dispatchflagAsInappropriate: PropTypes.func.isRequired,
  dispatchReviewsEligibility: PropTypes.func.isRequired,
  dispatchPostedReview: PropTypes.func.isRequired,
  reviews: PropTypes.object,
  reviewSummary: PropTypes.array,
  reviewSummaryData: PropTypes.object,
  reviewEligible: PropTypes.bool,
  reviewSubmitted: PropTypes.bool,
  designFileName: PropTypes.string,
  userType: PropTypes.oneOf([UNAUTHENTICATED, GUEST, REGISTERED]),
  displayModal: PropTypes.bool,
  modalName: PropTypes.string,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  windowPosition: PropTypes.number,
  reviewsIsFetched: PropTypes.bool,
  reviewsIsFetching: PropTypes.bool,
  isDesktop: PropTypes.bool.isRequired, // from parent
  s3host: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const props = {
    userType: state.user.userType,
    displayModal: state.pageSetup.modal.displayModal,
    modalName: state.pageSetup.modal.modalName,
    windowPosition: state.pageSetup.windowPosition,

    designName: state.design.name,
    designerUserName: state.design.designer.screen_name,
    designerDescription: state.design.designer.designer_description,
    designerId: state.design.designer.id,
    designFileName: state.design.filename,

    fabrics: state.fabrics,

    reviewsIsFetched: state.reviews.isFetched,
    reviewsIsFetching: state.reviews.isFetching,
    s3host: selectS3host(state),
  };

  if (objectIsEmpty(state.reviews.summary)) {
    return props;
  }

  return Object.assign(props, {
    reviews: state.reviews,
    reviewEligible: state.reviews.eligibility,
    reviewSummary: state.reviews.summary,
    reviewSummaryData: state.reviews.summary[0],
    reviewSubmitted: state.reviews.review_submitted
  });
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  dispatchReviews() {
    return dispatch(fetchReviews());
  },
  dispatchVotes(designId, reviewId, voteDirection) {
    return fetchVotes(dispatch, designId, reviewId, voteDirection);
  },
  dispatchflagAsInappropriate(designId, reviewId) {
    return fetchFlag(dispatch, designId, reviewId);
  },
  dispatchPostedReview(designId, review) {
    return fetchPostedReview(dispatch, designId, review);
  },
  dispatchReviewsEligibility(designId) {
    return fetchReviewsEligibility(dispatch, designId);
  },
  closeModal() {
    dispatch(modalClose({
      modal: {
        displayModal: false,
        modalName: ''
      }
    }));
  },
  openModal(name) {
    dispatch(modalOpen({
      modal: {
        displayModal: true,
        modalName: name
      }
    }));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewsContainer);
